"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp2, _class5, _descriptor10, _descriptor11, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var PeopleBlockList = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(PeopleBlockList, _Component3);

  function PeopleBlockList() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, PeopleBlockList);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(PeopleBlockList)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "people", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "sectionTitle", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(PeopleBlockList, [{
    key: "render",
    value: function render() {
      if (this.people.length) {
        return _react.default.createElement("div", {
          className: "people"
        }, this.sectionTitle && _react.default.createElement("h2", {
          className: "section-title"
        }, this.sectionTitle), this.people.map(function (entry) {
          return _react.default.createElement(PersonBlock, _extends({
            key: entry.id
          }, entry));
        }));
      }

      return null;
    }
  }]);
  return PeopleBlockList;
}(_react.Component), _temp3), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "sectionTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
})), _class5);
exports.default = PeopleBlockList;
var MaybeLink = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MaybeLink, _Component);

  function MaybeLink() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MaybeLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MaybeLink)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "href", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(MaybeLink, [{
    key: "render",
    value: function render() {
      return this.href ? _react.default.createElement("a", {
        href: this.href
      }, this.children) : _react.default.createElement("div", null, this.children);
    }
  }]);
  return MaybeLink;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "href", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var PersonBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PersonBlock, _Component2);

  function PersonBlock() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PersonBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PersonBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "photo", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "displayedName", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "bio", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "location", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "link", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "icons", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PersonBlock, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("div", {
        className: "person-photo"
      }, _react.default.createElement(MaybeLink, {
        href: this.link
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "image",
        noImageClassName: "initiaks",
        image: this.photo,
        name: this.displayedName
      }))), _react.default.createElement("div", {
        className: "person-body"
      }, _react.default.createElement("div", {
        className: "person-name"
      }, _react.default.createElement(MaybeLink, {
        href: this.link
      }, this.displayedName, this.icons.length ? _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          key: icon.id,
          src: icon.icon,
          className: "account-icon",
          title: icon.title
        });
      })) : null)), this.title && _react.default.createElement("div", {
        className: "person-title"
      }, this.title), this.location && _react.default.createElement("div", {
        className: "person-location"
      }, this.location), this.bio && _react.default.createElement("div", {
        className: "person-bio"
      }, this.bio)));
    }
  }]);
  return PersonBlock;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "photo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "displayedName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "bio", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "location", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);